import { TimeWindow } from '../models/monitoring.models';

export const SLOT_MINUTES = 15;

/** Fenêtre de la frise « État des DAT » : 1 h au total (décision du 30/06/2026). */
export const DAT_WINDOW_HALF_MINUTES = 30;

const PARIS_TIME_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Paris',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/**
 * Les minutes manipulées dans l'app (créneaux, segments, requêtes au back) restent dans
 * le référentiel UTC du back — seul l'affichage doit passer en heure de Paris (CET/CEST),
 * pour que les ASCT sur le terrain lisent l'heure de leur montre.
 */
export function utcMinutesToParisLabel(utcMinutesOfDay: number, referenceDate: Date = new Date()): string {
  const dayStartUtc = Date.UTC(
    referenceDate.getUTCFullYear(),
    referenceDate.getUTCMonth(),
    referenceDate.getUTCDate(),
  );
  const instant = new Date(dayStartUtc + utcMinutesOfDay * 60_000);
  const parts = PARIS_TIME_FORMATTER.formatToParts(instant);
  const hour = parts.find((p) => p.type === 'hour')?.value ?? '00';
  const minute = parts.find((p) => p.type === 'minute')?.value ?? '00';
  return `${Number(hour)}h${minute}`;
}

/** Créneau par défaut : le créneau de 15 min en cours (UTC, comme les données du back). */
export function currentSlotMinutes(now: Date = new Date()): number {
  const minutes = now.getUTCHours() * 60 + now.getUTCMinutes();
  return Math.floor(minutes / SLOT_MINUTES) * SLOT_MINUTES;
}

/**
 * Minutes écoulées depuis minuit heure de Paris (CET/CEST, DST-aware) pour l'instant donné.
 * À utiliser pour aligner une sélection par défaut sur l'heure que lit l'ASCT sur le terrain
 * (ex. plage horaire par défaut de l'écran historique) — à ne pas confondre avec les minutes
 * UTC utilisées pour interroger le back (cf. currentSlotMinutes), qui restent inchangées.
 */
export function parisMinutesOfDay(now: Date = new Date()): number {
  const parts = PARIS_TIME_FORMATTER.formatToParts(now);
  const hour = Number(parts.find((p) => p.type === 'hour')?.value ?? '0');
  const minute = Number(parts.find((p) => p.type === 'minute')?.value ?? '0');
  return hour * 60 + minute;
}

export function buildDatWindow(centerMinutes: number, referenceDate: Date = new Date()): TimeWindow {
  const startMinutes = centerMinutes - DAT_WINDOW_HALF_MINUTES;
  const endMinutes = centerMinutes + DAT_WINDOW_HALF_MINUTES;
  return {
    startMinutes,
    endMinutes,
    centerMinutes,
    startLabel: utcMinutesToParisLabel(startMinutes, referenceDate),
    endLabel: utcMinutesToParisLabel(endMinutes, referenceDate),
    centerLabel: utcMinutesToParisLabel(centerMinutes, referenceDate),
  };
}
